import React, { PropTypes } from 'react';
import cx from 'classnames';

import { KeyCodes } from 'constants/constants';


// ======================
// STORE
// ====================== 



// ======================
// PARTIALS
// ====================== 
export const ModalContent = ({ className, align, ...props }) => (
  <div className={cx("modal-content", className, align)} {...props}></div>
)

export const ModalLoading = ({ className, ...props }) => (
  <div className={cx("modal-content", className)} {...props}></div>
)

export const ModalContentStretch = ({ className, ...props }) => (
  <div className={cx("modal-content stretch", className)} {...props}></div>
)

export const ModalContentFill = ({ className, ...props }) => (
  <div className={cx("modal-content fill-height", className)} {...props}></div>
)

export const ModalHeader = ({ className, ...props }) => (
  <div className={cx("modal-header", className)} {...props}></div>
)

export const ModalTitle = ({ className, ...props }) => (
  <div className={cx("modal-title", className)} {...props}></div>
)
export const ModalSubtitle = ({ className, ...props }) => (
  <div className={cx("modal-subtitle", className)} {...props}></div>
)

export const ModalSectionTitle = ({ className, ...props }) => (
  <div className={cx("modal-section-title", className)} {...props}></div>
)

export const ModalNotice = ({ className, ...props }) => (
  <div className={cx("modal-notice", className)} {...props}></div>
)

export const ModalActions = ({ className, direction = 'row', align = 'center', ...props }) => (
  <div className={cx("modal-actions", className, direction, align)} {...props}></div>
)

export const ModalActionHelper = ({ className, ...props }) => (
  <div className={cx("modal-action-helper", className)} {...props}></div>
)



// ======================
// COMPONENT
// ====================== 
class Modal extends React.Component {
  static defaultProps = {
      open: true,
      showBackdrop: false,
      keyboard: true,
      backdropClassName: 'modal-back',
      className: 'modal',
      id: null,
      onClose: () => {}
  }

  _onKeyDown = (e) => {
    if(!this.props.open) 
      return;

    var {onClose, onRight, onLeft} = this.props;
    var keyCode = e.keyCode;
    if(!this.props.keyboard) 
      return;
    switch(keyCode) {
      case KeyCodes.ESCAPE:
      case KeyCodes.ENTER:
        onClose();
        break;
      case KeyCodes.RIGHT_ARROW:
        onRight ? onRight(e) : null;
        break;
      case KeyCodes.LEFT_ARROW:
        onLeft ? onLeft(e) : null;
        break;
    }
  }

  componentDidMount() {
    //if(this.props.open)
      //this.refs.modal.focus();
    window.addEventListener("keydown", this._onKeyDown, true);
  }

  componentWillUnmount() {
     window.removeEventListener("keydown", this._onKeyDown, true);
  }

  handleModalClick(e) {
    e.stopPropagation();
  }

  render() {
    let { open, showBackdrop, keyboard, backdropClassName, className, size = 'm', children, id, ...props} = this.props;
    return (
      <div
        id={id}
        className={cx('g-modal', className, size, {hide: !open, open: open})}
        onClick={this.handleModalClick}>
        { children }
      </div>);
  }
};
export default Modal;


export const ModalVertical = ({ className, ...props }) => (
  <Modal className={cx("fill-vert", className)} {...props} />
)

export const ModalFullScreen = ({ className, ...props }) => (
  <Modal className={cx("fullscreen", className)} {...props} />
)
